import React from 'react';
import { Columns, Column } from 'src/ui/mui-ui-kit';
import { Field } from 'react-final-form';
import propTypes from 'prop-types';
// import { FieldArray } from 'react-final-form-arrays';
import {
  UiFieldset,
  UiInputAdapter,
  UiToggleAdapter,
  // UiToggleGroup,
} from 'src/ui';
import { composeValidators, required, email } from 'src/ui/validations';
import { PHONE_MASK } from 'src/ui/const';
// import { INFORMATION_NEEDED_TOGGLES } from '../const';

export function AccountDataForm({
  allowsBanking,
  allowsPayment,
  allowsLending,
  allowsInsurance,
  // toggleHiddenPaymentsTab,
}) {
  const toggleSize = 'narrow'; // allowsPayment && allowsBanking && allowsLending ? 'narrow' : 'full';
  const [lendingChecked, setLendingChecked] = React.useState(allowsLending);
  return (
    <Columns isMultiline>
      <Column isSize="full" className="is-half-fullhd">
        <UiFieldset title="Business Information" isFirst>
          <Columns>
            <Column isSize="1/2">
              <Field
                component={UiInputAdapter}
                name="businessName"
                id="businessName"
                label="Business Name"
                required
                validate={composeValidators('Business Name', required)}
              />
            </Column>
          </Columns>
        </UiFieldset>

        <UiFieldset title="Administrator">
          <Columns isMultiline>
            <Column isSize="1/2">
              <Field
                component={UiInputAdapter}
                name="firstName"
                id="firstName"
                label="First Name"
                required
                validate={composeValidators('First Name', required)}
              />
            </Column>
            <Column isSize="1/2">
              <Field
                component={UiInputAdapter}
                name="lastName"
                id="lastName"
                label="Last Name"
                required
                validate={composeValidators('Last Name', required)}
              />
            </Column>
            <Column isSize="1/2">
              <Field
                component={UiInputAdapter}
                id="phoneNumber"
                name="phoneNumber"
                label="Phone"
                required
                mask={PHONE_MASK}
                validate={composeValidators('Phone', required)}
              />
            </Column>
            <Column isSize="1/2">
              <Field
                component={UiInputAdapter}
                id="emailAddress"
                name="emailAddress"
                label="E-mail"
                required
                validate={composeValidators('E-mail', required, email)}
              />
            </Column>
            <Column isSize="full">
              <Field
                component={UiToggleAdapter}
                id="sendEmail"
                name="sendEmail"
                type="checkbox"
                initialValue="on"
              >
                Send invitation email
              </Field>
            </Column>
          </Columns>
        </UiFieldset>
      </Column>
      <Column isSize="full" className="is-half-fullhd">
        <UiFieldset
          title="Services"
          // renderRight={
          //   <Field
          //     component={UiToggleAdapter}
          //     name="allServicesNeeded"
          //     id="allServicesNeeded"
          //     type="checkbox"
          //   >
          //     Select all
          //   </Field>
          // }
        >
          <Columns>
            {allowsBanking && !allowsInsurance && (
              <Column isSize={toggleSize}>
                <Field
                  component={UiToggleAdapter}
                  id="bankingService"
                  name="bankingService"
                  type="checkbox"
                  initialValue={lendingChecked}
                  disabled={lendingChecked}
                >
                  Banking
                </Field>
              </Column>
            )}
            {allowsPayment && !allowsInsurance && (
              <Column isSize={toggleSize}>
                <Field
                  component={UiToggleAdapter}
                  id="paymentService"
                  name="paymentService"
                  type="checkbox"
                  // onClick={toggleHiddenPaymentsTab}
                >
                  Payments
                </Field>
              </Column>
            )}
            {allowsLending && !allowsInsurance && (
              <Column isSize={toggleSize}>
                <Field
                  component={UiToggleAdapter}
                  id="lendingService"
                  name="lendingService"
                  type="checkbox"
                  onClick={() => setLendingChecked(!lendingChecked)}
                >
                  Lending
                </Field>
              </Column>
            )}
            {allowsInsurance && (
              <Column isSize={toggleSize}>
                <Field
                  component={UiToggleAdapter}
                  id="insuranceService"
                  name="insuranceService"
                  type="checkbox"
                  disabled
                >
                  Insurance
                </Field>
              </Column>
            )}
          </Columns>
        </UiFieldset>
      </Column>
      {allowsPayment && !allowsInsurance && (
        <Column isSize="full" className="is-half-fullhd">
          <UiFieldset title="Payments Information" isFirst>
            <Columns>
              <Column isSize="1/2">
                <Field
                  component={UiInputAdapter}
                  name="pricingFormat"
                  id="pricingFormat"
                  label="Pricing Format"
                  disabled
                />
              </Column>
              <Column isSize="1/2">
                <Field
                  component={UiInputAdapter}
                  name="processingType"
                  id="processingType"
                  label="Processing Type"
                  disabled
                />
              </Column>
            </Columns>
          </UiFieldset>

          <UiFieldset title="Payments Rate Information" isFirst>
            <Columns>
              <Column isSize="1/3">
                <Field
                  component={UiInputAdapter}
                  name="pinBasedDebitRate"
                  id="pinBasedDebitRate"
                  label="PIN Based Debit Rate %"
                />
                <Field
                  component={UiInputAdapter}
                  name="chargeBackFee"
                  id="chargeBackFee"
                  label="Chargeback Fee $"
                  disabled
                />
                <Field
                  component={UiInputAdapter}
                  name="salesTrxFee"
                  id="salesTrxFee"
                  label="Sales Trx Fee $"
                />
                <Field
                  component={UiInputAdapter}
                  name="monthlyMinimumFee"
                  id="monthlyMinimumFeessName"
                  label="Monthly Minimum Fee $"
                  disabled
                />
              </Column>
              <Column isSize="1/3">
                <Field
                  component={UiInputAdapter}
                  name="pciMonthlyProgramFee"
                  id="pciMonthlyProgramFee"
                  label="PCI Monthly Program Fee $"
                  disabled
                />
                <Field
                  component={UiInputAdapter}
                  name="retrievalFee"
                  id="retrievalFee"
                  label="Retrieval Fee $"
                  disabled
                />
                <Field
                  component={UiInputAdapter}
                  name="returnFee"
                  id="returnFee"
                  label="Return Fee $"
                  disabled
                />
                <Field
                  component={UiInputAdapter}
                  name="batchCloseFee"
                  id="batchCloseFee"
                  label="Batch Close Fee $"
                  disabled
                />
              </Column>
              <Column isSize="1/3">
                <Field
                  component={UiInputAdapter}
                  name="terminalIdFee"
                  id="terminalIdFee"
                  label="Terminal ID Fee $"
                  disabled
                />
                <Field
                  component={UiInputAdapter}
                  name="monthlyStatementFee"
                  id="monthlyStatementFee"
                  label="Monthly Statement Fee $"
                  disabled
                />
                <Field
                  component={UiInputAdapter}
                  name="onlinePortalFee"
                  id="onlinePortalFee"
                  label="Online Portal Fee $"
                  disabled
                />
                <Field
                  component={UiInputAdapter}
                  name="pciNonComplianceFee"
                  id="pciNonComplianceFee"
                  label="PCI Non-Compliance Fee $"
                  disabled
                />
              </Column>
              <Column isSize="1/3">
                <Field
                  component={UiInputAdapter}
                  name="achRejectFee"
                  id="achRejectFee"
                  label="ACH Reject Fee $"
                  disabled
                />
              </Column>
            </Columns>
          </UiFieldset>
        </Column>
      )}
    </Columns>
  );
}

AccountDataForm.propTypes = {
  allowsBanking: propTypes.bool.isRequired,
  allowsPayment: propTypes.bool.isRequired,
  allowsLending: propTypes.bool.isRequired,
  allowsInsurance: propTypes.bool.isRequired,
  // toggleHiddenPaymentsTab: propTypes.func.isRequired,
  // formData: propTypes.object.isRequired,
};
